import type { DiscoveredRouteModule } from '@/router/generator/types';

const AdminGroupsView = () => import('@/views/admin/GroupsView.vue');
const AdminGroupsIndexView = () => import('@/views/admin/groups/IndexView.vue');
const AdminGroupsEditView = () => import('@/views/admin/groups/EditView.vue');
const AdminGroupsBlogIndexView = () => import('@/views/groups/BlogView.vue');
const AdminGroupsBlogPostView = () => import('@/views/groups/blog/PostView.vue');
const AdminGroupsBlogCreateView = () => import('@/views/groups/blog/CreateView.vue');
const AdminGroupsBlogEditView = () => import('@/views/groups/blog/EditView.vue');

export const NAME_ADMIN_GROUPS = 'AdminGroups';
export const NAME_ADMIN_GROUPS_INDEX = 'AdminGroupsIndex';
export const NAME_ADMIN_GROUPS_EDIT = 'AdminGroupsEdit';
export const NAME_ADMIN_GROUPS_BLOG_INDEX = 'AdminGroupsBlogIndex';
export const NAME_ADMIN_GROUPS_BLOG_POST = 'AdminGroupsBlogPost';
export const NAME_ADMIN_GROUPS_BLOG_CREATE = 'AdminGroupsBlogCreate';
export const NAME_ADMIN_GROUPS_BLOG_EDIT = 'AdminGroupsBlogEdit';
export const PATH_ADMIN_GROUPS = 'groups';

export const route: DiscoveredRouteModule = {
  id: 'admin.groups',
  scope: 'admin',
  moduleKey: 'groups',
  name: NAME_ADMIN_GROUPS,
  path: PATH_ADMIN_GROUPS,
  component: AdminGroupsView,
  redirect: { name: NAME_ADMIN_GROUPS_INDEX },
  meta: { requiresAdmin: true, dataLoaders: ['project_document', 'features', 'project_groups', 'project_user_fields', 'admin_groups_algolia'] },
  children: [
    {
      path: '',
      component: AdminGroupsIndexView,
      name: NAME_ADMIN_GROUPS_INDEX,
      meta: { dataLoaders: ['project_document', 'features', 'project_groups', 'project_user_fields', 'admin_groups_algolia'] }
    },
    {
      path: ':groupId',
      component: AdminGroupsEditView,
      name: NAME_ADMIN_GROUPS_EDIT,
      meta: { dataLoaders: ['project_document', 'features', 'project_groups', 'project_user_fields', 'admin_groups_algolia'] }
    },
    // Blog routes (inactive feature - kept for future use)
    {
      path: 'blog',
      component: AdminGroupsBlogIndexView,
      name: NAME_ADMIN_GROUPS_BLOG_INDEX,
      meta: { dataLoaders: ['project_document', 'features', 'project_groups', 'groups_store', 'blog_posts'] }
    },
    {
      path: 'blog/post/:postId',
      component: AdminGroupsBlogPostView,
      name: NAME_ADMIN_GROUPS_BLOG_POST,
      meta: { dataLoaders: ['project_document', 'groups_store', 'blog_posts', 'blog_comments'] }
    },
    {
      path: 'blog/create',
      component: AdminGroupsBlogCreateView,
      name: NAME_ADMIN_GROUPS_BLOG_CREATE,
      meta: { dataLoaders: ['project_document', 'groups_store', 'blog_posts'] }
    },
    {
      path: 'blog/edit/:postId',
      component: AdminGroupsBlogEditView,
      name: NAME_ADMIN_GROUPS_BLOG_EDIT,
      meta: { dataLoaders: ['project_document', 'groups_store', 'blog_posts', 'blog_comments'] }
    }
  ]
};
